import {z} from 'zod';

/**
 * POST
 */
export const GetSupplierPriceListItemRequestSchema = z.object({
  body: z.object({
    catalogNumber: z.string().nullish(),
    manufacturerId: z.string().nullish(),
    supplierId: z.string().nullish(),
    supplierAccountCode: z.string().nullish(),
    supplierOrderTypeCode: z.string().nullish(),
    additionalInformation: z.boolean().nullish(),
    branchId: z.string().nullish(),
    authorizationProfileId: z.string().nullish(),
  }),
});

export type GetSupplierPriceListItemRequest = z.infer<typeof GetSupplierPriceListItemRequestSchema>;

export const GetSupplierPriceListItemResponseSchema = z
  .object({
    oemCode: z.string().nullish(),
    purchasePrice: z.number().nullish(),
    recommendedSellingPrice: z.number().nullish(),
    currency: z.string().nullish(),
    name: z.string().nullish(),
    shortOem: z.string().nullish(),
    discountGroup: z.string().nullish(),
    discountGroupPercent: z.number().nullish(),
    taxType: z.number().nullish(),
    measurementUnit: z.string().nullish(),
    tyreEnergyRating: z.string().nullish(),
    tyreNoiseRating: z.string().nullish(),
    manufacturer: z.string().nullish(),
    supplier: z.string().nullish(),
    priceListCode: z.string().nullish(),
    standardOrderQuantity: z.number().nullish(),
    totalStock: z.number().nullish(),
    localStock: z.number().nullish(),
    supplierOrderingNumber: z.string().nullish(),
    supplierManufacturerCode: z.string().nullish(),
    supplierManufacturerName: z.string().nullish(),
    checkSum: z.string().nullish(),
    manufacturerNumberNormalized: z.string().nullish(),
    supplierAccountCode: z.string().nullish(),
    supplierOrderTypeCode: z.string().nullish(),
    additionalInformation: z.string().nullish(),
  })
  .nullable();

export type GetSupplierPriceListItemResponse = z.infer<
  typeof GetSupplierPriceListItemResponseSchema
>;
